import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { PanelControls } from '~/components/ui/PanelControls';
import { IVehiclePassportAndHistory, rage, useInputAction } from '~/rage';
import { InputAction, Layouts } from '~/shared';
import { Card } from '../../components/Card';
import { History } from '../../components/History';
import { Info } from '../../components/Info';
import {
	StyledCardContainer,
	StyledCardsContainer,
	StyledContainer,
	StyledPanelControlsContainer,
} from './VehiclePassport.styled';

const VehiclePassport = () => {
	const [vehiclePassportAndHistory, setVehiclePassportAndHistory] =
		useState<IVehiclePassportAndHistory | null>(null);
	const [currentCard, setCurrentCard] = useState(0);
	const [hiddenCard, setHiddenCard] = useState(1);
	const [isEntering, setIsEntering] = useState(false);
	const [isExiting, setIsExiting] = useState(false);

	const handleNext = () => {
		if (isEntering || isExiting) {
			return;
		}

		if (currentCard === 1) {
			handlePrev();
			return;
		}

		setIsEntering(true);
		setIsExiting(true);
		setHiddenCard(currentCard);
		setCurrentCard((prevCard) => prevCard + 1);
		setTimeout(() => {
			setIsEntering(false);
			setIsExiting(false);
		}, 500);
	};

	const handlePrev = () => {
		if (isEntering || isExiting) {
			return;
		}

		if (currentCard === 0) {
			handleNext();
			return;
		}

		setIsEntering(true);
		setIsExiting(true);
		setHiddenCard(currentCard === 0 ? 1 : currentCard);
		setCurrentCard((prevCard) => prevCard - 1);
		setTimeout(() => {
			setIsEntering(false);
			setIsExiting(false);
		}, 500);
	};

	const controls = [
		{
			text: 'Сменить карточку',
			keys: ['Q', 'E'],
		},
		{
			text: 'Выйти',
			keys: ['Esc'],
			onClick: () =>
				rage.vehiclePassport
					.exit()
					.catch((err) => rage.notifications.showException(err)),
		},
	];

	useInputAction(InputAction.CommonTabNavLeft, handlePrev);
	useInputAction(InputAction.CommonTabNavRight, handleNext);
	useInputAction(InputAction.CommonMenuClose, () =>
		rage.vehiclePassport
			.exit()
			.catch((err) => rage.notifications.showException(err)),
	);

	useEffectOnce(() => {
		rage.vehiclePassport
			.getPassportAndHistory()
			.then((value) => setVehiclePassportAndHistory(value))
			.catch((err) => rage.notifications.showException(err));
	});

	return (
		<StyledContainer className={Layouts.VehiclePassport}>
			<StyledCardsContainer>
				{new Array(2).fill(null).map((_, index) => (
					<StyledCardContainer
						$isEntering={index === currentCard && isEntering}
						$isExiting={index === hiddenCard && isExiting}
						$isHidden={index === hiddenCard}
						key={index}
					>
						<Card
							name={vehiclePassportAndHistory?.passport?.name}
							docNumber={vehiclePassportAndHistory?.passport?.docNumber}
							vinNumber={vehiclePassportAndHistory?.passport?.vinNumber}
							isVisible={index === currentCard || index === hiddenCard}
							isHidden={index === hiddenCard}
							isEntering={index === currentCard && isEntering}
							isExiting={index === hiddenCard && isExiting}
						>
							{index === 0 && (
								<Info info={vehiclePassportAndHistory?.passport} />
							)}
							{index !== 0 && (
								<History
									history={vehiclePassportAndHistory?.lastOwnersHistory}
									duplicate={vehiclePassportAndHistory?.passport?.duplicate}
								/>
							)}
						</Card>
					</StyledCardContainer>
				))}
			</StyledCardsContainer>
			<StyledPanelControlsContainer>
				<PanelControls controls={controls} />
			</StyledPanelControlsContainer>
		</StyledContainer>
	);
};

export { VehiclePassport };
